import { z } from 'zod';

export const Meta = z.object({
  is_maintenance: z.boolean(),
  git_commit: z.string(),
});

export type Meta = z.infer<typeof Meta>;

export const PatchMeta = Meta.pick({
  is_maintenance: true,
});

export type PatchMeta = z.infer<typeof PatchMeta>;

export const PdfMeta = z.object({
  PORT: z.number(),
  MODE: z.string(),
  MAX_WORKERS: z.number(),
  SETUP_PUPPETEER: z.boolean(),
  NODE_ENV: z.string(),
  GIT_COMMIT: z.string(),
  GITHUB_COMMIT: z.string(),
});

export type PdfMeta = z.infer<typeof PdfMeta>;
